import './style.less';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import Icon from 'telstra-ui/components/icons/Icon';
import { NavLink } from 'react-router-dom';
import { loading } from '@redux/actions/loading'


interface IPageLazyLoadingIndicatorProps {
    error: boolean;
}

export function PageLazyLoadingIndicator(props:IPageLazyLoadingIndicatorProps) {
    const { error } = props;
    const dispatch = useDispatch()
    const hideGlobalSpinner = () => dispatch(loading(false));
    const showGlobalSpinner = () => dispatch(loading(true))

    const tryAgain = () => {
        return window.location.reload();
    }

    React.useEffect(() => {
        showGlobalSpinner();
    },[])

    const renderPageLoadError = () => {
        hideGlobalSpinner();
        const tryAgainElem = (
            <span onClick={tryAgain} className="try-again-styling">
                try again
            </span>
        );

        const renderPageCenter = (component) => {
            return (
                <div className="tc-oe">
                    <div id="tc-oe-page-load-center">
                        <div className="tc-oe-page-load-indicator-container">
                            {component}
                        </div>
                    </div>
                </div>
            );
        }

        return renderPageCenter(
            <div className="server-error-with-cloud row">
                <div className="size-error-component col-sm-12">
                    <div className="align-error-cloud">
                        <svg className="icon-size">
                            <Icon name="icon-system-server-error" />
                        </svg>
                    </div>
                    <div className="hidden-xs try-again body18">
                        <span>
                            The system is unresponsive. Please {tryAgainElem} in a few minutes.
                        </span>{' '}
                        <span>If that does not fix it, please
                            <NavLink to="/app/support/error-report">{' '}report this error</NavLink>.
                        </span>
                    </div>
                    <div className="visible-xs">
                        <div className="mobile-view-try-again body18">
                            <span>The system is unresponsive. Please {tryAgainElem} in a few minutes. </span>
                            <span>If that does not fix it, please
                                <NavLink to="/app/support/error-report">{' '}report this error</NavLink>.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    if (error) {
        return renderPageLoadError();
    }
    return null;
}